"use strict";

import React, {Component} from "react";
import {NavLink, withRouter} from "react-router-dom";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import ReactTable from "react-table";
import "react-table/react-table.css";

import ViolationLevelIcon from "./ViolationLevelIcon";

import moment from "moment";

const EnrichedVideoTable = withRouter(class EnrichedVideoTable extends Component {

    static defaultProps = {
        manual: false,
        loading: true,
        data: [],
        filtered: [],
        pages: 0,
        onFetchData: () => {},
        defaultPageSize: 20,
        defaultSorted: [{id: "lastModifiedDate", desc: true}],
        defaultSortDesc: true,
    };

    static propTypes = {
        manual: PropTypes.bool,
        loading: PropTypes.bool,
        data: PropTypes.array,
        filtered: PropTypes.array,
        pages: PropTypes.number,
        onFetchData: PropTypes.func,
        defaultPageSize: PropTypes.number,
        defaultSorted: PropTypes.array,
        defaultSortDesc: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        // this.state = {...props};
    }

    render() {
        // const { manual, loading, data, filtered, pages } = this.state;
        const { manual, loading, data, filtered, pages, onFetchData, defaultPageSize, defaultSorted, defaultSortDesc } = this.props;
        let manualProps = {};
        if (manual) {
            manualProps["pages"] = pages;
        }
        return (
            <ReactTable
                columns={[
                    {
                        Header: "",
                        id: "violation",
                        accessor: d => d,
                        Cell: d => (
                            <ViolationLevelIcon enrichedVideo={ d.value } />
                        ),
                        width: 30,
                    },
                    {
                        Header: "",
                        id: "videoMetaIdLink",
                        accessor: "videoMetaId",
                        Cell: d => (
                            <NavLink key={"/enriched-video/" + d.value} to={"/enriched-video/" + d.value}>
                                <FontAwesomeIcon icon={"chevron-circle-right"}
                                                 fixedWidth={true} />
                            </NavLink>
                        ),
                        width: 30,
                    },
                    {
                        Header: "Video Meta Id",
                        id: "id",
                        accessor: "videoMetaId",
                    },
                    {
                        Header: "Video Title",
                        id: "title",
                        accessor: "title",
                    },
                    {
                        Header: "",
                        id: "programIdLink",
                        accessor: "programId",
                        Cell: d => (
                            d.value
                            ? <NavLink key={"/enriched-videos-by-program/" + d.value} to={"/enriched-videos-by-program/" + d.value}>
                                  <FontAwesomeIcon icon={"chevron-circle-right"}
                                                   fixedWidth={true} />
                              </NavLink>
                            : ''
                        ),
                        width: 30,
                    },
                    {
                        Header: "Program Id",
                        id: "program.id",
                        accessor: "programId",
                    },
                    {
                        Header: "Series Id",
                        id: "program.seriesId",
                        accessor: "seriesId",
                    },
                    {
                        Header: "Season Id",
                        accessor: "seasonId",
                    },
                    {
                        Header: "Program Title",
                        id: "program.title",
                        accessor: "programTitle",
                    },
                    {
                        Header: "Season",
                        id: "seasonNumber",
                        accessor: d => d.seasonNumber ? d.seasonNumber : '',
                    },
                    {
                        Header: "Episode",
                        id: "episode",
                        accessor: d => d.episode ? d.episode : '',
                    },
                    {
                        Header: "Slug",
                        accessor: "slug",
                    },
                    {
                        Header: "Gen. Ref.",
                        id: "externalReference.genRef",
                        accessor: "genRef",
                    },
                    {
                        Header: "Last Modified",
                        id: "lastModifiedDate",
                        accessor: d => moment(d.lastModifiedDate).local().format("YYYY-MM-DD HH:mm:ss"),
                    },
                ]}
                manual={manual} // Forces table not to paginate or sort automatically, so we can handle it server-side
                {... manualProps} // Display the total number of pages
                loading={loading} // Display the loading overlay when we need it
                data={data}
                filtered={filtered}
                defaultPageSize={defaultPageSize}
                defaultSorted={defaultSorted}
                defaultSortDesc={defaultSortDesc}
                onFetchData={onFetchData} // Request new data when things change
                className="-striped -highlight"
                style={{
                    height: "450px",
                }}
            />
        );
    }
});

export default EnrichedVideoTable;
